module.exports = __webpack_public_path__ + "img/1F1EC-1F1FE.830ac62b.svg";